// extracted by mini-css-extract-plugin
module.exports = {"pokemonImage":"Pokemon_pokemonImage__33fBU","pokemonName":"Pokemon_pokemonName__YMUsS","pokemonContainer":"Pokemon_pokemonContainer__1o_cG"};